import LeaveDialogue from './LeaveDialogue';

export default LeaveDialogue;
